import React from "react";
export default function DraggableSubSectionItem({
  boxColor,
  boxNumber,
  handleDrag,
  handleDrop,
  detail,
}) {
  return (
    <li
      draggable={true}
      id={boxNumber}
      onDragOver={(ev) => ev.preventDefault()}
      onDragStart={handleDrag}
      onDrop={handleDrop}
      style={{ color: "black", backgroundColor: "#2a93db", fontSize: "16px" }}
      className="py-1 px-2 MuiListItem-root MuiListItem-padding tab  css-1tnift2-MuiListItem-root"
    >
      <span
        className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeDefault MuiButton-textSizeDefault MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeDefault MuiButton-textSizeDefault has-leading"
        style={{ color: "black", fontSize: "16px" }}
      >
        {detail?.text}
      </span>
    </li>
  );
}
